/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PluginFailuresSummaryResponse interface.
 */
export function instanceOfPluginFailuresSummaryResponse(value) {
    if (!('byStage' in value) || value['byStage'] === undefined)
        return false;
    if (!('date' in value) || value['date'] === undefined)
        return false;
    if (!('totalToday' in value) || value['totalToday'] === undefined)
        return false;
    return true;
}
export function PluginFailuresSummaryResponseFromJSON(json) {
    return PluginFailuresSummaryResponseFromJSONTyped(json, false);
}
export function PluginFailuresSummaryResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'byStage': json['by_stage'],
        'date': json['date'],
        'totalToday': json['total_today'],
    };
}
export function PluginFailuresSummaryResponseToJSON(json) {
    return PluginFailuresSummaryResponseToJSONTyped(json, false);
}
export function PluginFailuresSummaryResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'by_stage': value['byStage'],
        'date': value['date'],
        'total_today': value['totalToday'],
    };
}
